module.exports = __webpack_public_path__ + "@/assets/img/go-top-icon.10be37f0.png";